import React, { useState } from 'react';
import styles from './explore.module.css'
import Rrequest from './Rrequest';
import Srequest from './Srequest';
import Suggestion from './suggestion';
const Explore =()=>{

    const [nav,setNav]=useState("suggestion");
const acst={backgroundColor:"#AA55FD",color:"white"}

    return(
        <div className={styles.container}>
            <div className={styles.header}>
            <div className={styles.headerTop}>
                <h2>Explore</h2>
                <br/>
            </div>
            <div className={styles.topOption}>
                <div className={styles.navbtn}>
                    <button style={nav==="suggestion"?acst:{}}  onClick={()=>setNav("suggestion")} >Suggestion</button>
                    <button style={nav==="received"?acst:{}}  onClick={()=>setNav("received")} >Received Request</button>
                    <button style={nav==="send"?acst:{}}  onClick={()=>setNav("send")} >Send Request</button>
                </div>
                <div className={styles.search}>
                    <input placeholder="Search by name or username"/>

                </div>

            </div>
            </div>

            {nav==="suggestion"?
            <Suggestion/>:""}
            {nav==="received"?
            <Rrequest/>:""}
            {nav==="send"?
            <Srequest/>:""}

          

        </div>
    )
}

export default Explore